import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import LoginForm from './LoginForm';
import GoogleButton from './GoogleButton';
import { useI18n } from '../../contexts/I18nContext';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n();
  const [showContactAnimation, setShowContactAnimation] = useState(false);
  
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <motion.div className="card w-full max-w-md overflow-hidden" initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center relative">
              <button onClick={onClose} className="absolute top-3 right-3 px-2 py-1 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-700" aria-label={t('close')}>
                ✕
              </button>
              <motion.img src="/logo.png" alt="Zeta AI" className="w-14 h-14 mx-auto mb-4" initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} />
              <h2 className="text-2xl font-bold mb-1">{t('loginTitle')}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">{t('loginSubtitle')}</p>

              <LoginForm onSuccess={onClose} onShowContactAnimation={setShowContactAnimation} />

              <div className="my-4 text-gray-500">{t('or')}</div>
              <GoogleButton onSuccess={onClose} />

               <a 
                 href="https://forms.gle/" 
                 target="_blank" 
                 rel="noreferrer" 
                 className="mt-6 inline-block text-sm text-gray-600 dark:text-gray-300 hover:underline"
               >
                 {t('contactUsCTA')}
               </a>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LoginModal;


